import { EShapeCabinetType } from "../../../core/ShapeTypes/EShapeCabinetType";
import { DrawCabinetShape } from "./DrawCabinetShape";


class DrawS1CabinetShape extends DrawCabinetShape {
   
    get Shape(): EShapeCabinetType {
        return EShapeCabinetType.S1;
    }
}

export default DrawS1CabinetShape;
